    // ========================================
    // CALCULATEUR DE QUANTITÉS
    // ========================================

    const CONCRETE_PRODUCTS = [
        "Béton"
    ];

    const CRUSHED_STONE = "Pierres concassées";
    const CRUSHED_STONE_DENSITY = 1.8;
    const IMPERIAL_TO_M3 = 0.00235974;
    const IMPERIAL_CRUSHED_STONE_TO_TONNES = 0.00424753;

    const placeholders = {
        imperial: {
            longueur: "Longueur/pieds",
            largeur: "Largeur/pieds",
            epaisseur: "Épaisseur/pouces"
        },
        metric: {
            longueur: "Longueur/mètres",
            largeur: "Largeur/mètres",
            epaisseurConcrete: "Épaisseur/centimètres",
            epaisseurCrushedStone: "Épaisseur/mètres"
        }
    };

    function getDimensionLabels(system, product) {
        if (system === 'imperial') {
            return placeholders.imperial;
        }

        return {
            longueur: placeholders.metric.longueur,
            largeur: placeholders.metric.largeur,
            epaisseur: isConcreteProduct(product)
                ? placeholders.metric.epaisseurConcrete
                : placeholders.metric.epaisseurCrushedStone
        };
    }

    function getSystem() {
        return $('input[name="systeme"]:checked').val() || 'imperial';
    }

    function isConcreteProduct(product) {
        return CONCRETE_PRODUCTS.indexOf(product) !== -1;
    }

    function isCrushedStone(product) {
        return product === CRUSHED_STONE;
    }

    function isValidProduct(product) {
        return isConcreteProduct(product) || isCrushedStone(product);
    }

    function formatNumber(value) {
        return value.toLocaleString('fr-CA', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    function updateDimensionFields() {
        const system = getSystem();
        const product = $('#produits').val();
        const labels = getDimensionLabels(system, product);

        $('label[for="longueur"]').text(labels.longueur);
        $('label[for="largeur"]').text(labels.largeur);
        $('label[for="epaisseur"]').text(labels.epaisseur);

        $('#longueur').attr('placeholder', labels.longueur);
        $('#largeur').attr('placeholder', labels.largeur);
        $('#epaisseur').attr('placeholder', labels.epaisseur);
    }

    function updateUnitLabel(product) {
        if (isCrushedStone(product)) {
            $('#quantite-unite').text('tonnes');
        } else if (isConcreteProduct(product)) {
            $('#quantite-unite').text('m³');
        } else {
            $('#quantite-unite').text('');
        }
    }

    function calculateQuantity() {
        const selectedProduct = $('#produits').val();
        const longueur = parseFloat($('#longueur').val()) || 0;
        const largeur = parseFloat($('#largeur').val()) || 0;
        const epaisseur = parseFloat($('#epaisseur').val()) || 0;
        const system = getSystem();

        updateUnitLabel(selectedProduct);
        updateDimensionFields();

        if (!isValidProduct(selectedProduct)) {
            $('#quantite').val('').removeData('numeric-value');
            updateButtonState();
            return;
        }

        if (longueur <= 0 || largeur <= 0 || epaisseur <= 0) {
            $('#quantite').val('').removeData('numeric-value');
            updateButtonState();
            return;
        }

        let result;

        if (isConcreteProduct(selectedProduct)) {
            if (system === 'metric') {
                result = longueur * largeur * (epaisseur / 100);
            } else {
                result = longueur * largeur * epaisseur * IMPERIAL_TO_M3;
            }
        } else {
            if (system === 'metric') {
                result = longueur * largeur * epaisseur * CRUSHED_STONE_DENSITY;
            } else {
                result = longueur * largeur * epaisseur * IMPERIAL_CRUSHED_STONE_TO_TONNES;
            }
        }

        $('#quantite')
            .val(formatNumber(result))
            .data('numeric-value', result.toFixed(2));

        updateButtonState();
    }

    function updateButtonState() {
        const selectedProduct = $('#produits').val();
        const quantite = parseFloat($('#quantite').data('numeric-value')) || 0;
        const $btnCommander = $('#btn-commander');

        if (selectedProduct && selectedProduct !== "" && quantite > 0) {
            $btnCommander.removeClass('disabled');
            const urlParams = new URLSearchParams({
                produit: selectedProduct,
                quantite: quantite.toFixed(2)
            });
            $btnCommander.attr('href', 'coordonnees.php?' + urlParams.toString());
        } else {
            $btnCommander.addClass('disabled');
            $btnCommander.attr('href', '#');
        }
    }

    $('input[name="systeme"]').on('change', function() {
        updateDimensionFields();
        calculateQuantity();
    });

    $('#produits').on('change', function() {
        updateDimensionFields();
        calculateQuantity();
    });
    $('#longueur, #largeur, #epaisseur').on('input', calculateQuantity);

    $('#btn-commander').on('click', function(e) {
        if ($(this).hasClass('disabled')) {
            e.preventDefault();
            return false;
        }
    });

    updateDimensionFields();
    updateButtonState();

    // ========================================
    // FIN CALCULATEUR
    // ========================================
